import React, { useState } from "react";
import { useTheme } from "@mui/styles";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Box, Button, Typography } from "@mui/material";
import { useStyles } from "../../../theme/style";
import ViewCardsSetting from "../Component/ViewCardsSetting";
import TableView from "./TableView";
import APP_CONSTANTS, { MESSAGES } from "../../../utils/config";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import GridViewCard from "../Component/GridViewCard";
import noDataImage from "../../../../assets/images/No_Data.svg";
import SearchBar from "../../../components/Search/SearchBar";
// import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { useDispatch } from "react-redux";
import { updateAlertInfo } from "../../../redux/slice/userSlice";
import Tooltip from "../../../kit/Tooltip";
// import { getUserBillingDashboardUrl } from "../../../services/api";
import { getUserMonitoringDashboardUrl } from "../../../services/api";
import MonitorIcon from '@mui/icons-material/Monitor';

function AdminLandingPage({ data }) {
  const [selectedView, setSelectedView] = useState(APP_CONSTANTS.TABLE_VIEW);
  const [showApp, setShowApp] = useState("all-application");
  const theme = useTheme();
  const classes = useStyles(theme);
  const [localData, setLocalData] = useState(data);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleViewChange = (view) => {
    setSelectedView(view);
  };

  const showPendingOrAllApps = (appView) => {
    if (appView === "all-application") {
      setLocalData(data);
    } else if (appView === "pending-application") {
      const filteredData = data.filter((item) => {
        const { status } = item;
        return status === APP_CONSTANTS.RAPID_STATUS.PENDING_INFORMATION;
      });
      setLocalData(filteredData);
    } else if (appView === "llm-garden") {
      const hardcodedData = [
        {
          app_description: "Admin LLM Garden",
          app_name: "Admin",
          created_at: "2025-09-18T10:43:12.101146",
          product_lines: ["Admin"],
          product_streams: ["Admin"],
          project_name: "Admin",
          region: ["Admin"],
          request_id: "Admin",
          status: "FINISHED",
          updated_at: "2025-09-18T10:43:12.101148",
          user_id: "Admin",
        },
      ];
      setLocalData(hardcodedData);
    }
    setShowApp(appView);
  };

  const requestSearch = (val) => {
    let currData = data;
    const query = val;
    const filteredData = currData.filter((item) => {
      const { request_id, app_name, project_name, status } = item;

      return (
        request_id.toLowerCase().includes(query.toLowerCase()) ||
        app_name.toLowerCase().includes(query.toLowerCase()) ||
        project_name.toLowerCase().includes(query.toLowerCase()) ||
        status.toLowerCase().includes(query.toLowerCase())
      );
    });

    setLocalData(filteredData);
  };

  return (
    <div
      style={{
        margin: theme.size[24],
        height: "calc(100vh - 103px)",
      }}
    >
      {/* Heading and new resource button */}
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: theme.size[26],
          }}
        >
          <Typography
            sx={{
              fontWeight: theme.fontWeight[500],
              fontSize: theme.size[20],
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "calc(100vw - 480px)",
            }}
          >
            {MESSAGES.RAPID}
          </Typography>
          <div
            style={{
              display: "flex",
              gap: theme.size[8],
              alignItems: "center",
            }}
          >
            <Button
              disableRipple
              className={classes.outlinedButton}
              onClick={() => navigate("/rapid")}
              sx={{
                fontWeight: theme.fontWeight[500], 
                height: 44, 
                width: 44,
                minWidth: 44,
                padding: 0,
                color: "#1D387E",
                borderColor: "#1D387E",
                borderRadius: "8px",
                transition: "all 0.2s ease-in-out",
                '&:hover': {
                  backgroundColor: "#1D387E",
                  borderColor: "#1D387E",
                  transform: "translateY(-1px)",
                  boxShadow: "0 4px 12px rgba(29, 56, 126, 0.3)",
                  '& .MuiSvgIcon-root': {
                    color: "white",
                  }
                }
              }}
            >
              <Tooltip 
                title={
                  <span style={{ 
                    backgroundColor: "#1D387E", 
                    color: "white", 
                    padding: "8px 12px",
                    borderRadius: "6px",
                    display: "block",
                    border: "none",
                    fontSize: "12px",
                    fontWeight: "500",
                    textAlign: "center"
                  }}>
                    Exit Admin Portal
                  </span>
                }
                placement="top"
                PopperProps={{
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      backgroundColor: 'transparent !important',
                      padding: 0,
                      border: 'none',
                    }
                  }
                }}
              >
                <LogoutIcon
                  sx={{
                    fontSize: 20,
                    color: "#1D387E",
                    transform: "rotate(180deg)",
                    transition: "color 0.2s ease-in-out"
                  }}
                />
              </Tooltip>
            </Button>
            <Button
              disableRipple
              className={classes.outlinedButton}
              onClick={async () => {
                try {
                  const response = await getUserMonitoringDashboardUrl();
                  const authToken = response.data.data.data.jwt_token;
                  const dashboardUrl = response.data.data.data.dashboard_url;
                  const finalDashboardurl = `${dashboardUrl}&auth_token=${authToken}`;
                  window.open(finalDashboardurl, '_blank');
                } catch (error) {
                  console.error('Error fetching billing dashboard:', error);
                  dispatch(updateAlertInfo({
                    message: 'Error fetching billing dashboard',
                    open: true,
                    severity: 'error',
                  }));
                }
              }}
              sx={{
                fontWeight: theme.fontWeight[500], 
                height: 44, 
                width: 44,
                minWidth: 44,
                padding: 0,
                color: "#1D387E",
                borderColor: "#1D387E",
                borderRadius: "8px",
                transition: "all 0.2s ease-in-out",
                '&:hover': {
                  backgroundColor: "#1D387E",
                  borderColor: "#1D387E",
                  transform: "translateY(-1px)",
                  boxShadow: "0 4px 12px rgba(29, 56, 126, 0.3)",
                  '& .MuiSvgIcon-root': {
                    color: "white",
                  }
                }
              }}
            >
              <Tooltip 
                title={
                  <span style={{ 
                    backgroundColor: "#1D387E", 
                    color: "white", 
                    padding: "8px 12px",
                    borderRadius: "6px",
                    display: "block",
                    border: "none",
                    fontSize: "12px",
                    fontWeight: "500",
                    textAlign: "center"
                  }}>
                    Monitoring Dashboard
                  </span>
                }
                placement="top"
                PopperProps={{
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      backgroundColor: 'transparent !important',
                      padding: 0,
                      border: 'none',
                    }
                  }
                }}
              >
                <MonitorIcon sx={{ fontSize: 20, color: "#1D387E", transition: "color 0.2s ease-in-out" }} />
              </Tooltip>
            </Button>
            <Button
              disableRipple
              className={classes.outlinedButton}
              onClick={() => {
                navigate("/rapid/register-rapidApplication");
              }}
              sx={{
                fontWeight: theme.fontWeight[500], 
                height: 44, 
                width: 44,
                minWidth: 44,
                padding: 0,
                color: "#1D387E",
                borderColor: "#1D387E",
                borderRadius: "8px",
                transition: "all 0.2s ease-in-out",
                '&:hover': {
                  backgroundColor: "#1D387E",
                  borderColor: "#1D387E",
                  transform: "translateY(-1px)",
                  boxShadow: "0 4px 12px rgba(29, 56, 126, 0.3)",
                  '& .MuiSvgIcon-root': {
                    color: "white",
                  }
                }
              }}
            >
              <Tooltip 
                title={
                  <span style={{ 
                    backgroundColor: "#1D387E", 
                    color: "white", 
                    padding: "8px 12px",
                    borderRadius: "6px",
                    display: "block",
                    border: "none",
                    fontSize: "12px",
                    fontWeight: "500",
                    textAlign: "center"
                  }}>
                    Request New Application
                  </span>
                }
                placement="top"
                PopperProps={{
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      backgroundColor: 'transparent !important',
                      padding: 0,
                      border: 'none',
                    }
                  }
                }}
              >
                <AddRoundedIcon sx={{ fontSize: 20, color: "#1D387E", transition: "color 0.2s ease-in-out" }} />
              </Tooltip>
            </Button>
          </div>
        </div>
      </div>

      {/* search and change view button*/}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <Button
            disableRipple
            className={
              showApp === "all-application"
                ? classes.filledButton
                : classes.outlinedButton
            }
            onClick={() => showPendingOrAllApps("all-application")}
            style={{
              fontWeight: theme.fontWeight[500],
              marginRight: theme.size[8],
              padding: `${theme.size[4]} ${theme.size[8]}`,
              borderRadius: theme.size[30],
            }}
          >
            <span>All Applications</span>
          </Button>
          <Button
            disableRipple
            className={
              showApp === "pending-application"
                ? classes.filledButton
                : classes.outlinedButton
            }
            onClick={() => showPendingOrAllApps("pending-application")}
            style={{
              fontWeight: theme.fontWeight[500],
              padding: `${theme.size[4]} ${theme.size[8]}`,
              borderRadius: theme.size[30],
              marginRight: theme.size[8],
            }}
          >
            <span>Pending Requests</span>
          </Button>
          <Button
            disableRipple
            className={
              showApp === "llm-garden"
                ? classes.filledButton
                : classes.outlinedButton
            }
            onClick={() => showPendingOrAllApps("llm-garden")}
            style={{
              fontWeight: theme.fontWeight[500],
              padding: `${theme.size[4]} ${theme.size[8]}`,
              borderRadius: theme.size[30],
            }}
          >
            <span>LLM Garden</span>
          </Button>
        </div>
        <div
          style={{
            marginBottom: theme.size[16],
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <div>
            <SearchBar
              requestSearch={requestSearch}
              placeholder={"Search"}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: theme.size[5],
                border: `1px solid ${theme.palette.rapid.lightGrey}`,
                width: theme.size[300],
                marginRight: theme.size[10],
                padding: `${theme.size[2]} ${theme.size[8]}`,
                marginTop: "0px",
              }}
            />
          </div>
          <ViewCardsSetting
            disabled={false}
            currentView={selectedView}
            handleViewChange={handleViewChange}
          />
        </div>
      </div>

      {/* Table view, Grid View */}
      {localData.length === 0 ? (
        <div
          style={{
            height: "calc(100% - 100px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: theme.palette.primary.searchBackgroundChat,
            borderRadius: theme.size[5],
            flexDirection: "column",
          }}
        >
          <img
            style={{
              maxHeight: "25vh",
              width: "100%",
              marginBottom: theme.size[10],
            }}
            src={noDataImage}
            alt="no-data-img"
          />
          <Typography
            sx={{
              fontSize: theme.size[14],
              color: theme.palette.primary.darkViolet,
              fontWeight: theme.fontWeight[500],
              marginBottom: theme.size[16],
            }}
          >
            You don't have any Pending Request.
          </Typography>
        </div>
      ) : selectedView === APP_CONSTANTS.CARD_VIEW ? (
        <Box
          style={{
            gap: "1rem",
            overflowX: "wrap",
            scrollBehavior: "smooth",
            flexGrow: "1",
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gridAutoColumns: "auto",
            gridRowGap: "1rem",
            gridColumnGap: "1rem",
          }}
        >
          {localData.map((singleApp) => (
            <GridViewCard app={singleApp} />
          ))}
        </Box>
      ) : (
        <TableView rowData={localData} isAdmin={true} />
      )}
    </div>
  );
}

export default AdminLandingPage;
